// eslint-disable-next-line import/prefer-default-export
export const LocationFormControlName = {
  City: 'city',
  Province: 'province',
  Community: 'community',
};
